export const MEASUREMENT_ID = 'G-T7C0ZRR6ZN';

export const ANALYTICS_HOSTS = Object.freeze([
  'coureau.me',
  'harry.coureau.me',
  'coureau.au',
  'harry.coureau.au',
  'coureau.net',
]);

const SCRIPT_ID = 'google-analytics';

export function isAnalyticsHost(hostname) {
  return ANALYTICS_HOSTS.includes(String(hostname).toLowerCase());
}

export function init({ win = window, doc = document } = {}) {
  if (!isAnalyticsHost(win.location.hostname)) return false;
  if (doc.getElementById(SCRIPT_ID)) return true;

  // Google Tag reads commands from this global queue when its script loads.
  win.dataLayer = win.dataLayer || [];
  function gtag() {
    win.dataLayer.push(arguments);
  }

  gtag('js', new Date());
  gtag('set', 'linker', { domains: ANALYTICS_HOSTS });
  gtag('config', MEASUREMENT_ID);

  const script = doc.createElement('script');
  script.id = SCRIPT_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  doc.head.appendChild(script);

  return true;
}
